import { createMenu } from './create-menu.js';

const getMenuItems = (name, component, page)=>{
    var ref, ref1;
    const menuDocumentRef = (ref1 = (ref = component === null || component === void 0 ? void 0 : component.getComponent(name)) === null || ref === void 0 ? void 0 : ref.getModels()) === null || ref1 === void 0 ? void 0 : ref1.menu;
    const menu = menuDocumentRef && (page === null || page === void 0 ? void 0 : page.getContent(menuDocumentRef));
    return {
        menuItems: createMenu(menu, page),
        menu
    };
};

export { getMenuItems };
//# sourceMappingURL=get-menu-items.js.map
